import React from 'react'
import Button from '../UI/Button'

export default function SlideItem({title, description, btnName, btnLink, bottleSrc, bottleBaseSrc, slideItemClassName}) {

  return ( 
    <div className={`slide-item d-flex ${slideItemClassName}`}>  
        <div className="bottle d-inline-block text-center"> 
            <div className="img-bottle d-inline-block"><img src={bottleSrc} alt=""/></div> 
            <div className="img-bottle-base d-inline-block"><img src={bottleBaseSrc} alt=""/></div> 
        </div>
        <div className="text-content">
            <h4 className="title-md">{title}</h4>
            <p className="des">{description}</p>
            <Button href={btnLink}>{btnName}</Button>
        </div>
    </div>
  ) 
} 